(() => {
  if (window.gradzoPersonalizationGuard) return;
  window.gradzoPersonalizationGuard = true;
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.querySelector('[data-gradzo-personalization]')) return;
    const fields = [...form.elements].filter(el => el.name && el.name.startsWith('properties[') && !el.disabled && el.type !== 'hidden');
    const texts = fields.filter(el => (el instanceof HTMLTextAreaElement || ['text', 'search'].includes(el.type)) && el.getClientRects().length);
    const validText = texts.some(el => el.value.trim());
    const invalidRequired = fields.find(el => el.required && !el.checkValidity());
    const notice = form.querySelector('[data-gradzo-personalization-message]');
    if (!validText || invalidRequired) {
      event.preventDefault();
      event.stopImmediatePropagation();
      notice.hidden = false;
      notice.textContent = texts.length ? 'Please enter your personalization and complete the required options before adding this item to your cart.' : 'Personalization options have not loaded. Please refresh this page or contact service@customempireshop.com before ordering.';
      if (invalidRequired || texts[0]) (invalidRequired || texts[0]).focus();
      else notice.focus();
    } else {
      notice.hidden = true;
    }
  }, true);
})();
